import { Roles } from "../../constants/roles";
import { FormBase } from "../../util/form-base-form";

class PostsInfiniteScrollForm extends FormBase {
    public getContainer(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, ".container", HTMLElement);
    }

    public getHiddenPostDetails(root: ParentNode): HTMLElement[] {
        return this.queryElements(
            root,
            `[data-role="${Roles.POST_DETAIL}"][data-hidden-role="${Roles.POST_DETAIL_HIDDEN}"][data-post-id]`,
            HTMLElement,
        );
    }

    public getHiddenPostDetailById(root: ParentNode, postKey: string): HTMLElement | null {
        return this.queryElement(
            root,
            `[data-role="${Roles.POST_DETAIL}"][data-hidden-role="${Roles.POST_DETAIL_HIDDEN}"][data-post-id="${postKey}"]`,
            HTMLElement,
        );
    }
}

const postsInfiniteScrollForm = new PostsInfiniteScrollForm();

export { postsInfiniteScrollForm };
